import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import FontCreatorAuthContainer from './fontCreatorAuth/FontCreatorAuthContainer';
import FontCreatorNotAuthContainer from './fontCreatorNotAuth/FontCreatorNotAuthContainer';
import { useAuth } from '../auth/useAuth';

const FontCreatorContainer: FC = () => {
  const { isAuth } = useAuth();

  return (
    <div className="bg-white min-h-screen">
      <Helmet>
        <title>Писака | Создать свой рукописный шрифт онлайн</title>
        <meta name="description" content="Создайте свой рукописный шрифт онлайн. Загрузите шаблон, заполните буквы и получите уникальный шрифт для генератора конспектов." />
        <meta name="keywords" content="создать рукописный шрифт, генератор шрифтов онлайн, свой шрифт онлайн, шрифт от руки онлайн, создать шрифт, генератор рукописных шрифтов, рукописный шрифт онлайн" />
        <link rel="canonical" href="https://pisaka.online/font-creator/" />
      </Helmet>
      {isAuth ? <FontCreatorAuthContainer /> : <FontCreatorNotAuthContainer />}
    </div>
  );
};

export default FontCreatorContainer;
